// PEGA ESTE CÓDIGO COMPLETO EN src/components/client/ServerCatalog.tsx

import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { AuthUser } from '../../types';

const catalogData = [
  { ref: 'L01', processor: 'Dual Intel Xeon, 16c/32t (E5-2667 V2)', ram: '64 GB', hd: '1 TB', connection: '1 Gbps', price: '180,00€', paymentLink: 'https://buy.stripe.com/8x2bJ1gz25l9f3c90AdnW0I' },
  { ref: 'L02', processor: 'Dual Intel Xeon, 16c/32t (E5-2667 V2)', ram: '128 GB', hd: '2 TB', connection: '1 Gbps', price: '210,00€', paymentLink: 'https://buy.stripe.com/9B63cv4QkaFt8EO5OodnW0J' },
  { ref: 'L03', processor: 'Dual Intel Xeon, 16c/32t (E5-2650 V2)', ram: '64 GB', hd: '1 TB', connection: '10 Gbps', price: '300,00€', paymentLink: 'https://buy.stripe.com/aFadR93MgeVJ4oy6SsdnW0K' },
  { ref: 'L04', processor: 'Dual Intel Xeon, 16c/32t (E5-2667 V2)', ram: '128 GB', hd: '2 TB', connection: '10 Gbps', price: '350,00€', paymentLink: 'https://buy.stripe.com/8x228r3MgfZNg7gccMdnW0L' },
  { ref: 'L05', processor: 'Dual Intel Xeon, 16c/32t (E5-2667 V2)', ram: '256 GB', hd: '2 TB', connection: '10 Gbps', price: '450,00€', paymentLink: 'https://buy.stripe.com/4gMcN5fuYcNBaMWccMdnW0M' },
  { ref: 'L06', processor: 'Dual Intel Xeon, 20c/40t (E5-2650 V3)', ram: '64 GB DDR4', hd: '1 TB', connection: '10 Gbps', price: '400,00€', paymentLink: 'https://buy.stripe.com/14A00jdmQcNB5sC6SsdnW0N' },
  { ref: 'L07', processor: 'Dual Intel Xeon, 24c/48t (E5-2630 V3)', ram: '128 GB DDR4', hd: '2 TB', connection: '10 Gbps', price: '500,00€', paymentLink: 'https://buy.stripe.com/00w28rbeI14T4oyfoYdnW0O' },
  { ref: 'L08', processor: 'Dual Intel Xeon, 28c/56t (E5-2690 V4)', ram: '256 GB DDR4', hd: '2 TB', connection: '10 Gbps', price: '600,00€', paymentLink: 'https://buy.stripe.com/9B6cN55Uo6pdcV45OodnW0P' },
];

interface ServerCatalogProps {
  user: AuthUser | null;
}

export const ServerCatalog: React.FC<ServerCatalogProps> = ({ user }) => {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-900">Catálogo de Servidores Disponibles</h2>
      <p className="text-gray-600">Ubicación: Amsterdam</p>
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ref.</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Procesador</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">RAM</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">HD</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Conexión</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Precio</th>
                <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Acción</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {catalogData.map((server) => (
                <tr key={server.ref} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{server.ref}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{server.processor}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{server.ram}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{server.hd}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{server.connection}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-semibold text-gray-900">{server.price}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-center">
                    <a
                      href={`${server.paymentLink}?client_reference_id=${user?.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center justify-center w-full px-3 py-2 rounded-md text-sm font-medium text-white bg-green-600 hover:bg-green-700 transition-all duration-200"
                    >
                      <ShoppingCart className="w-4 h-4" />
                      <span className="ml-2">Contratar</span>
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
